import { render, staticRenderFns } from "./multipleDocumentsUpload.vue?vue&type=template&id=c675799c&scoped=true&"
import script from "./multipleDocumentsUpload.vue?vue&type=script&lang=js&"
export * from "./multipleDocumentsUpload.vue?vue&type=script&lang=js&"
import style0 from "./multipleDocumentsUpload.vue?vue&type=style&index=0&id=c675799c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c675799c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\corpmessengerwebapp_rtp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c675799c')) {
      api.createRecord('c675799c', component.options)
    } else {
      api.reload('c675799c', component.options)
    }
    module.hot.accept("./multipleDocumentsUpload.vue?vue&type=template&id=c675799c&scoped=true&", function () {
      api.rerender('c675799c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/LMSGiframe/components/multipleDocumentsUpload.vue"
export default component.exports